module.exports = __webpack_public_path__ + "static/img/SelectTopic03.2897cbc.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/SelectTopic03.png
// module id = MXXp
// module chunks = 24